export const downloadFile = (file) => {
  // Kreirajte URL za datoteku koristeći Blob API
  const fileURL = URL.createObjectURL(new Blob([file], { type: file.type }));

  // Kreirajte privremeni link za preuzimanje
  const link = document.createElement('a');
  link.href = fileURL;
  link.setAttribute('download', file.name);

  // Dodajte link u DOM
  document.body.appendChild(link);

  // Kliknite na link da biste pokrenuli preuzimanje
  link.click();

  // Uklonite link iz DOM-a
  document.body.removeChild(link);
};
